
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[...wordpressCalculatorsMtgEN]",
      function () {
        return require("private-next-pages/[...wordpressCalculatorsMtgEN].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[...wordpressCalculatorsMtgEN]"])
      });
    }
  